<template>
  <div id="app" class="d-flex flex-column">
    <main-nav v-if="!isMaintenancePage"></main-nav>
    <main
      v-if="!needsPortalContent"
      :class="!mx_breadcrumb ? 'nav-space' : ''"
    >
      <div class="bread-crumbs d-flex align-items-center" v-if="mx_breadcrumb">
        <b-button class="crumb" variant="link" :to="mx_breadcrumbUrl">
          <font-awesome-icon
            class="mr-2"
            :icon="['far', 'arrow-left']"
          />{{ mx_breadcrumb.text }}
        </b-button>
      </div>
      <router-view />
    </main>
    <portal-content v-else></portal-content>
    <main-footer v-if="!needsPortalContent && !isMaintenancePage"></main-footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { ifacBreadcrumbMixin } from '@ifac/ui';
import MainNav from '@/views/layouts/MainNav.vue';
import MainFooter from '@/views/layouts/MainFooter.vue';
import PortalContent from '@/views/layouts/PortalContent.vue';
import initRefData from '@/services/refData';

const pjson = require('../package.json');

export default {
  data() {
    return {
      hasLoadedRefData: false,
    };
  },
  mixins: [ifacBreadcrumbMixin],
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
    }),
    currentVersion() {
      return {
        app: pjson.version,
        ui: pjson.dependencies['@ifac/ui'],
      };
    },
    needsPortalContent() {
      return ['ApprovalsDetails', 'NominationsEdit', 'ReportsEdit']
        .includes(this.$route.name);
    },
    isMaintenancePage() {
      return this.$route.name === 'Maintenance';
    },
  },
  components: {
    MainNav,
    MainFooter,
    PortalContent,
  },
  methods: {
    maybeInitRefData() {
      if (!this.isAuthenticated || this.isMaintenancePage || this.hasLoadedRefData) {
        return;
      }

      this.hasLoadedRefData = true;
      initRefData();
    },
  },
  watch: {
    isAuthenticated(authenticated) {
      if (authenticated) {
        this.maybeInitRefData();
      }
    },
    isMaintenancePage() {
      this.maybeInitRefData();
    },
  },
  created() {
    this.maybeInitRefData();
    console.info('Version', this.currentVersion);
  },
};
</script>

<style>
main {
  padding: 1.875rem;
}
</style>
<style lang='scss'>
@import '@/assets/styles/base/_variables.scss';
@import '@/assets/styles/base/_mixins.scss';

.bread-crumbs {
  padding-left: 0.8rem;
  border-bottom: 1px solid $color-grey-light;
  margin-bottom: 2rem;
  font-size: 14px;

  .btn-link {
    padding: 0.75rem;
    color: inherit;
    &:focus {
      text-decoration: none;
    }
    &:hover {
      text-decoration: none;
    }
  }
}
</style>
